export default __webpack_public_path__ + "static/Perroquet-3D-01-8e7eadd9013714fd647863675e59d4da.jpeg";